import React, { useMemo } from 'react';
import { LeftOutline } from 'antd-mobile-icons';
import { useNavigate } from 'react-router-dom';

/**
 * 悬浮返回按钮组件
 * @param {Function} onClick - 自定义点击事件（可选）
 * @param {Object} style - 自定义样式（可选）
 * @param {Boolean} flex - 是否使用 flex 固定布局（可选）
 * @returns {JSX.Element} 返回按钮组件
 */
const FloatBackButton = ({ onClick, style, flex = false }) => {
  const navigate = useNavigate();

  // 默认点击事件：返回上一页
  const handleClick = () => {
    if (onClick) {
      onClick();
    } else {
      // 检查当前路径，如果是首页则不执行任何操作
      if (window.location.pathname === '/') {
        return;
      }
      
      // 尝试返回上一页
      // 在微信浏览器中，即使 history.length > 1，也不一定真的能返回到有效页面
      // 所以我们优先尝试返回，如果返回后仍在当前页面，则跳转到首页
      const currentPath = window.location.pathname + window.location.search;
      
      // 添加一个临时标记用于检测是否真的发生了页面跳转
      sessionStorage.setItem('returnCheck', currentPath);
      
      // 尝试返回上一页
      navigate(-1);
      
      // 使用 setTimeout 检查是否真的发生了页面跳转
      setTimeout(() => {
        const checkPath = sessionStorage.getItem('returnCheck');
        const currentFullPath = window.location.pathname + window.location.search;
        
        // 如果路径没有改变，说明返回无效，应该跳转到首页
        if (checkPath === currentFullPath) {
          navigate('/');
        }
        
        // 清除临时标记
        sessionStorage.removeItem('returnCheck');
      }, 100);
    }
  };

  const flexStyle = useMemo(() => {
    console.log('useMemo---flex=',flex);
    return flex ? { 
        position: 'fixed',
        top: '0.75rem',
        left: '1rem',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
    } : {};}, [flex]);

  return (
    <button
      onClick={handleClick}
      style={{
        // 基础样式
        width: '35px',
        height: '35px',
        borderRadius: '50%',
        backgroundColor: 'rgba(0, 0, 0, 0.5)', // 透明灰色背景
        border: 'none',
        zIndex: 999, // 确保悬浮在最上层
        ...flexStyle,
        // 自定义样式覆盖默认
        ...style,
      }}
      aria-label="返回"
    >
      <LeftOutline
        style={{
          color: '#fff',
          fontSize: '20px',
        }}
      />
    </button>
  );
};

export default FloatBackButton;